import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["masked", "value", "eyeButton", "copyButton"]
  static values = { text: String }

  reveal() {
    this.maskedTarget.classList.add("hidden")
    this.eyeButtonTarget.classList.add("hidden")
    this.valueTarget.textContent = this.textValue
    this.valueTarget.classList.remove("hidden")
    this.copyButtonTarget.classList.remove("hidden")
    this.copyButtonTarget.classList.add("flex")
  }
}
